import type { ReactElement } from 'react';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import HelpLinkButton from 'atom-components/buttons/help-link-button/help-link-button';
import IconButton from 'atom-components/buttons/icon-button';
import { useAuth } from 'services/providers/auth.provider';
import { getThemeTitle, useTheme } from 'services/providers/theme.provider';
import MainMenu from './main-menu';
import UserDropdown from './user-dropdown';
import './sidebar.scss';

type Props = {
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function SidebarFull({ setSidebarOpen }: Props): ReactElement {
  const { theme } = useTheme();

  const handleSideBarToggle = (): void => {
    setSidebarOpen((sidebarOpen) => !sidebarOpen);
  };

  const { isMasquerading, endMasquerade } = useAuth();

  return (
    <aside className="sidebar open">
      <div className="sidebar-header">
        <Link to="/">
          <img src="/assets/logo@3x.png" className="nzcer-logo" alt="NZCER" />
        </Link>
        {getThemeTitle(theme) && <b className="theme-title">{getThemeTitle(theme)}</b>}{' '}
        <div className="sidebar-close-wrapper">
          <button
            type="button"
            className="sidebar-close btn btn-sm btn-light rounded-pill"
            onClick={handleSideBarToggle}
          >
            <FontAwesomeIcon icon="angles-left" className="fa-fw" size="lg" />
            Close
          </button>
        </div>
        {isMasquerading && (
          <IconButton
            icon="anchor"
            className="btn btn-danger m-1"
            onClick={(): Promise<void> => endMasquerade()}
          >
            Stop Masquerade
          </IconButton>
        )}
        <UserDropdown />
      </div>
      <MainMenu expanded />
      <div className="d-flex mx-auto mt-auto h4">
        <HelpLinkButton />
      </div>
      <div className="text-muted text-monospace text-center">
        v{APP_VERSION.match(/[0-9]{8}-[0-9]/)}
      </div>
    </aside>
  );
}
